import { QUIZ } from '~/consts';

export default async function ({ store, redirect, $axios, error, route, query }) {
  const authorization_status = route.meta[1].status;

  const { data } = await $axios.post(QUIZ.RUNNING_QUIZ(query.id));
  const data_res = data.data;

  if (data.applicationSystem.code == 0 && !helpers.isEmpty(data_res)) {
    if (data_res.status == authorization_status) {
      store.commit('quizes/setRunnedQuiz', data_res);
    } else if (data_res.status == 1) {
      return redirect('/embed/quiz')
    } else if (data_res.status == 2) {
      return redirect(`/embed/classes/${data_res.group_id}/sections/${data_res.post.classScheduleId}/${data_res.postId}`);
    }
  } else {
    return redirect('/embed/classes')
  }
}
